import Vue from 'vue'
import Router from 'vue-router'
// import { constantRouterMap,dynamicRouter,devOpsRouter } from "@/config/router.config";

//路由懒加载
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/login',
      hidden: true,
      meta: { title: "登录", icon: '' },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      hidden: true,//在菜单显示还是隐藏
      meta: { title: "登录", icon: '' },
    },
    {
      path: '/largeDataScreen',
      component: () => import('@/views/largeDataScreen/index.vue'),
      meta: { title: "数据大屏", icon: '' },
    },
    {
      path: '/home',
      component: () => import('@/views/home/index.vue'),
      meta: { title: "首页", icon: '' },
      redirect: '/guidance',
      children: [
        {
          path: '/guidance',
       component: () => import('@/views/guidance/index.vue'),
          meta: { title: "首页", icon: '' },
        },
        {
          path: '/instrument',
       component: () => import('@/views/instrument/index.vue'),
          meta: { title: "仪器管理", icon: '' },
        },
        {
          path: '/instrument/config',
       component: () => import('@/views/instrument/components/addOrRedactInstruments/index.vue'),
          meta: { title: "新建编辑仪器", icon: '' },
        },
        {
          path: '/maintain',
       component: () => import('@/views/maintain/index.vue'),
          meta: { title: "维养管理", icon: '' },
        },
        {
          path: '/warehouseManage',
       component: () => import('@/views/warehouseManage/index.vue'),
          meta: { title: "库房管理", icon: '' },
        },
         {
          path: '/warehouseManage/list',
       component: () => import('@/views/warehouseManage/configuration/index.vue'),
          meta: { title: "仓库配置", icon: '' },
        },
         {
          path: '/warehouseManage/list/config',
       component: () => import('@/views/warehouseManage/configuration/addWarehouse.vue'),
          meta: { title: "仓库配置", icon: '' },
        },
        {
          path: '/applyFor',
       component: () => import('@/views/applyFor/index.vue'),
          meta: { title: "申请管理", icon: '' },
        },
        {
          path: '/project',
       component: () => import('@/views/project/index.vue'),
          meta: { title: "项目管理", icon: '' },
        },
        {
          path: '/user',
       component: () => import('@/views/user/index.vue'),
          meta: { title: "用户管理", icon: '' },
        },

        {
          path: '/company',
       component: () => import('@/views/company/index.vue'),
          meta: { title: "公司管理", icon: '' },
        },
        {
          path: '/company/config',
       component: () => import('@/views/company/configuration.vue'),
          meta: { title: "配置", icon: '' },
        },
        {
          path: '/standard',
       component: () => import('@/views/standard/index.vue'),
          meta: { title: "规范库管理", icon: '' },
        },
        {
          path: '/calibrationUnit',
       component: () => import('@/views/calibrationUnit/index.vue'),
          meta: { title: "第三方检定校准单位管理", icon: '' },
        },
        {
          path: '/operation',
       component: () => import('@/views/operation/index.vue'),
          meta: { title: "运维管理", icon: '' },
        },
          {
          path: '/vertify',
       component: () => import('@/views/vertify/index.vue'),
          meta: { title: "送检管理", icon: '' },
        },
        
      ]
    },
   
    
  ]
});



// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next();
  } else {
    let token = sessionStorage.getItem('Authorization');
    if (token === null || token == undefined || token == '') {
      next('/login');
    } else {
      const rt = JSON.parse(sessionStorage.getItem('store'));
      // 判断用户属于那种角色，就添加那种路由
      // console.log("--------------->", rt);
      if (rt) {
        router.options.routes = rt.user.router;
      }
      next();
    }
  }
});

// 定义一个resetRouter 方法，在退出登录后或token过期后 需要重新登录时，调用即可
export function resetRouter () {
  const newRouter = new Router({
    mode: 'history',
    routes: router
  });
  router.matcher = newRouter.matcher
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js